import i18next from "i18next";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function useTerritorialDistribution() {
  const { t } = useTranslation();
  const [filters, setFilters] = useState({ filter1: 'all', filter2: 'all' });

  const filtersConfig = useMemo(() => ({
    language: i18next.language,
    filtersConfig: {
      filter1: {
        type: 'select',
        label: '',
        placeholder: (t) => t(''),
        style: { flex: 1 },
        labelStyle: { flex: 1 },
      },
      filter2: {
        type: 'select',
        label: '',
        placeholder: (t) => t(''),
        style: { flex: 1 },
        labelStyle: { flex: 1 },
      },
    },
    onApply: (val) => setFilters(val),
    options: {
      filter1: [{ label: t('All'), value: 'all' }],
      filter2: [{ label: t('All'), value: 'all' }],
    },
    selectedFilters: filters,
    type: 'small',
    t,
  }), [t, i18next.language, filters]);

  return {
    filters,
    filtersConfig,
  };
}
